/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ScheduledPaymentViewModel {
  id?: string;
  patientId?: string;
  token?: string | null;
  paymentStartDate?: string | null;
  paymentEndDate?: string | null;
  amountType?: number | null;
  customAmount?: number | null;
  paymentFrequency?: number | null;
  frequencyDays?: number | null;
  frequencyDayOfMonth?: number | null;
  frequencyDayOfWeek?: number | null;
  nextPaymentDate?: string | null;
  lastPaymentDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
}
